import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProfileAPI from "apiConfig/ProfileAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  data: null,
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncEditUsername = createAsyncThunk(
  "accountSetting/fetchAsyncEditUsername",
  async ({ userId, firstname, lastname }, { rejectWithValue }) => {
    try {
      const response = await ProfileAPI.patch(`/profiles/${userId}`, {
        firstNameTH: firstname,
        firstNameEN: firstname,
        lastNameTH: lastname,
        lastNameEN: lastname,
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const EditUsernameSlice = createSlice({
  name: "editUsername",
  initialState,
  reducers: {
    resetEditUsername: state => {
      state.data = null;
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncEditUsername.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchAsyncEditUsername.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.status = Status.LOADED;
      })
      .addCase(fetchAsyncEditUsername.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetEditUsername } = EditUsernameSlice.actions;
export default EditUsernameSlice.reducer;
